import React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { RootState } from '../../store';
import Modal from '../layout/Modal/Modal';
import { hideOrderRevisionConflict } from '../../store/order/actions';

interface StateProps {
    visible: boolean;
}

interface DispatchProps {
    hide: () => void;
}

type Props = StateProps & DispatchProps;

const OrderRevisionConflictModal: React.FC<Props> = ({ visible, hide }) => {
    if (!visible) {
        return null;
    }

    return (
        <Modal
            isShowing={visible}
            hide={hide}
            hideClose={true}
            hideHeader={true}
            size="md"
            children={(
                <div className="order-changed-modal">
                    <h2 className="order-changed-modal__title">Order was changed by another user</h2>
                    <p className="order-changed-modal__text">
                        The order was changed by another user before your change was saved.
                        We have loaded the latest version. Please review and try again.
                    </p>
                </div>
            )}
            footer={(
                <div className="order-changed-modal__footer">
                    <button
                        type="button"
                        className="po__order-btn order-changed-modal__btn order-changed-modal__btn--primary"
                        onClick={hide}
                    >
                        OK
                    </button>
                </div>
            )}
        />
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    visible: state.order.order.orderRevisionConflictVisible,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): DispatchProps => ({
    hide: () => dispatch(hideOrderRevisionConflict()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderRevisionConflictModal);
